import { instance } from 'utils/api';

export type AnalysisRow = {
  id: number;
  title?: string | null;
  summary?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  analysis?: Record<string, any> | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  file?: Record<string, any> | null;
  status: string;
  createdAt: string;
};

// GET /analyses/patient/:id — {results, total}; pagination is 1-based
// (legacy GQL sent page: 0).
export const fetchAnalysesByPatient = async (
  patientId: number | string,
  params: { page?: number; limit?: number; search?: string; sort?: number }
): Promise<{ results: AnalysisRow[]; total: number }> => {
  const res = await instance.get<{ results: AnalysisRow[]; total: number }>(
    `analyses/patient/${patientId}`,
    { params }
  );

  return res.data;
};

export const fetchAnalysisById = async (
  id: number | string
): Promise<AnalysisRow> => {
  const res = await instance.get<AnalysisRow>(`analyses/${id}`);

  return res.data;
};
